<template>
  <!-- Header Section -->
  <div class="header-section">
    <div class="title-section">
      <h1 class="main-title">{{ steps[currentStep].name }}</h1>
      <p class="step-indicator">{{ getText((currentStep + 1), steps.length) }}</p>
    </div>
    <div class="description">
      <p v-html="steps[currentStep].description"></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'StepHeader',
  props: {
    currentStep: { type: Number, required: true },
    steps: { type: Array, required: true },
  },
  data() {
    return {
      lang: {
        W00009: "Step PLACEHOLDER1 of PLACEHOLDER2",
      }
    }
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) { 
      this.globals.getLanguageStrings(this);
    }
  },
  methods: {
    getText(placeholder1Text, placeholder2Text) {
      return this.lang.W00009.replace("PLACEHOLDER1", placeholder1Text).replace("PLACEHOLDER2", placeholder2Text)
    }
  }
}
</script>

<style lang="css" scoped>

.header-section {
  margin-bottom: 32px;
  text-align: left;

  /* @media (min-width: 1024px) {
    margin-bottom: 64px;
  } */
}

.title-section {
  margin-bottom: 24px;
}

.main-title {
  font-weight: 500;
  font-size: 32px;
  line-height: 1.4;
  letter-spacing: 0.0088px;
  color: #252424;
  margin: 0px;

  @media (min-width: 1024px) {
    font-size: 44px;
  }
}

.step-indicator {
  font-size: 14px;
  color: #666666;
}

.description {
  font-size: 16px;
  line-height: 1.6;
  color: #252424;

  p {
    white-space: pre-line;
  }
}

</style>



// WEBPACK FOOTER //
// StepHeader.vue?7b438546